// Confirm dialog gestito via store (chiamata imperativa)
import { create } from 'zustand';
import { Modal } from './Modal';
import { Button } from './Button';

interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  onConfirm: () => void | Promise<void>;
}

interface ConfirmState extends ConfirmOptions {
  open: boolean;
  loading: boolean;
  ask: (opts: ConfirmOptions) => void;
  close: () => void;
  confirm: () => Promise<void>;
}

const useConfirmStore = create<ConfirmState>((set, get) => ({
  title: '',
  message: '',
  confirmText: 'Conferma',
  cancelText: 'Annulla',
  danger: false,
  onConfirm: () => {},
  open: false,
  loading: false,
  ask: (opts) => set({ ...opts, open: true }),
  close: () => set({ open: false, loading: false }),
  confirm: async () => {
    set({ loading: true });
    try {
      await get().onConfirm();
      set({ open: false, loading: false });
    } catch (e) {
      console.error('[confirm] error', e);
      set({ loading: false });
    }
  },
}));

export function confirmDialog(opts: ConfirmOptions) {
  useConfirmStore.getState().ask(opts);
}

export function ConfirmHost() {
  const s = useConfirmStore();
  return (
    <Modal
      open={s.open}
      onClose={() => !s.loading && s.close()}
      title={s.title}
      size="sm"
      footer={
        <div className="flex gap-2 justify-end">
          <Button variant="ghost" onClick={() => s.close()} disabled={s.loading}>
            {s.cancelText}
          </Button>
          <Button variant={s.danger ? 'danger' : 'primary'} loading={s.loading} onClick={() => s.confirm()}>
            {s.confirmText}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-slate-600 dark:text-slate-300">{s.message}</p>
    </Modal>
  );
}
